import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import {
  CardReplacementReasons,
  CardReplaceReason,
} from '@/modules/transaction/components/Cards/Cards.types';

interface DefaultReplacementFields {
  REPLACEMENT_REASON: string;
}

const REPLACEMENT_REASONS = [
  { key: CardReplaceReason.LOST, value: CardReplacementReasons.LOST },
  { key: CardReplaceReason.STOLEN, value: CardReplacementReasons.STOLEN },
  { key: CardReplaceReason.NOT_SENT, value: CardReplacementReasons.NOT_RECEIVED },
  { key: CardReplaceReason.DAMAGED, value: CardReplacementReasons.DAMAGED },
  { key: CardReplaceReason.DEMOGRAPHIC_CHANGE, value: CardReplacementReasons.DEMOGRAPHIC_CHANGE },
];

const FIELDS: DefaultReplacementFields = {
  REPLACEMENT_REASON: 'reason',
};

export default () => {
  const fields: Field[] = useMemo(() => {
    const source: Field[] = [
      {
        name: FIELDS.REPLACEMENT_REASON,
        type: FieldTypes.Dropdown,
        singleMode: true,
        label: 'Replacement reason',
        placeholder: 'Select reason',
        validator: yup.string().required(REQUIRED_TEXT),
        options: REPLACEMENT_REASONS,
        defaultValue: '', // generalInfo?.reason,
      },
    ];
    return source;
  }, []);

  return fields;
};
